module.exports = __webpack_public_path__ + "img/avatar-88.7872c832.png";